
<template>
    <div class="forgot-password login-page" id="login">
        <div class="login-content">
            <div class="login-logo text-center">
                <img :src="imagePath" alt="FleetPro Application">
            </div>
            <div class="login-container">
                <h2 class="mb-3">Forgot your password?</h2>
                <div class="form-row">
                    <div class="col form-group">
                        <input name="email" v-model="email" id="email" class="form-control" placeholder="Username" type="text">
                        <div class="field-error">{{ forgot_pass_err_msg }}</div>
                    </div>
                </div>
                <div class="alert alert-warning hide form-group" id="alertError">
                    <button type="button" class="close" @click="hideAlert('warning')" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong id="error-msg" class="field-error"></strong>
                </div>
                <div class="alert alert-success hide form-group" id="alertError">
                    <button type="button" @click="hideAlert('success')" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong id="success-msg" class="field-success"></strong>
                </div>
                <div class="btn-groups mt-4">
                    <button class="btn btn-secondary" v-on:click="loginPage()">Back</button>
                    <button id="checkemailbtn" class="btn btn-primary" style="margin-left:5px;" type="submit" v-on:click="emailVerify()">Submit</button>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

    import EventBus from './event-bus.js';

    export default {
        name: "forgotpassword",
        data: () => ({
            imagePath: process.env.LOGO_PATH,
            forgot_pass_err_msg : "",
            email: "",
            error:""
        }),
        created: function() {

        },
        mounted: function() {

            var self = this;
            var tokenData = self.$route.query.token;
            var emailData = self.$route.query.email;

            if (tokenData != undefined) {

                $.ajax({
                    url: process.env.ROOT_API + "/checkuser",
                    type: "GET",
                    crossDomain: true,
                    data: {
                        tokenValue: tokenData,
                        email: emailData
                    },
                    dataType: 'json',
                    success: function (data) {

                        // console.log(data.content);
                        if (data.status == "success" && data.code == 200 ) {
                            self.$router.push("/resetpassword/" + data.content);
                        }
                    },
                    error: function (jqXHR, exception) {

                        self.Registerbtn = "Register";
                        if (jqXHR.status == 0) {
                            self.registerError = "Remote server cannot be reached";
                        }
                    }
                });
            }

            //hide header
            EventBus.$emit('logged-in', false,"","","");

            $(document).ready(function(){
                $("#login").height($(window).height() + 'px');
            });
            $(window).resize(function(){
                $("#login").height($(window).height() + 'px');
            });
            $("input").keypress(function(e) {
                if (e.keyCode === 13) {
                    if (e.target.id == 'email') {
                        self.emailVerify();
                    }
                }
            });
        },
        methods: {
            hideAlert(flag){
                if (flag == 'success') {
                    $(".alert-success").removeClass("show");
                    $(".alert-success").addClass("hide");
                } else {
                    $(".alert-warning").addClass("hide");
                    $(".alert-warning").removeClass("show");
                }
            },
            loginPage() {
                var self = this;
                self.$router.push("/");
            },

            emailVerify: function () {

                var self = this;
                self.forgot_pass_err_msg = "";
                var error = false;

                if (self.email == "" || !self.email || self.email == null) {
                    self.forgot_pass_err_msg = "Email can not be left empty";
                    error = true;
                }
                //as user need to enter username so commenting this
                // if (self.email && !self.validEmail(self.email)) {
                //     self.forgot_pass_err_msg = "Enter Valid Email.";
                //     error = true;
                // }

                if (!error) {

                    $("#checkemailbtn").html("Submiting...");
                    $("#checkemailbtn").prop("disable",true);

                    $.ajax({
                        url: process.env.ROOT_API + "/checkuser",
                        type: "GET",
                        crossDomain: true,
                        dataType: 'json',
                        data: {
                            email: self.email,
                            flag: 'forgot'
                        },
                        success: function (data) {
                            $("#checkemailbtn").html("Submit");
                            $("#checkemailbtn").prop("disable",false);
                            if (data.status == "success") {
                                $("#success-msg").text("Reset password link has been sent to your email address.");
                                $(".alert-success").removeClass("hide");
                                $(".alert-success").addClass("show");
                            } else if ( data.status == 'Error' ) {
                                self.forgot_pass_err_msg = "User not found.";
                            }else if (data.status == 'Email_not_found'){
                                self.forgot_pass_err_msg = data.message;
                            }

                        },
                        error: function (jqXHR, exception) {

                            // self.Loginbtn = "Login";
                            $("#checkemailbtn").html("Submit");
                            $("#checkemailbtn").prop("disable",false);

                            if (jqXHR.status == 0) {
                                self.error = "Remote server cannot be reached";
                            } else {
                                self.error = jQuery.parseJSON(jqXHR.responseText).message;
                            }
                            $("#error-msg").html(jqXHR.responseJSON.message);
                            $(".alert-warning").removeClass("hide");
                            $(".alert-warning").addClass("show");
                        }
                    });
                }
            },

            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
        }
    };
</script>
<style scoped>
.field-success {
    color: rgb(0 129 30);
    font-size: 12px;
    display: block;
    line-height: 14px;
    margin: 5px 0 0 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/ForgotPassword.vue